if (!customElements.get('view-as')) {
  class ViewAs extends HTMLElement {
    constructor() {
      super();

      this.handleUpdateRef = this.handleUpdate.bind(this);
    }

    handleUpdate(event) {
      if (!event.detail.type) return;

      this.setAttribute('css-type', event.detail.type);
    }

    connectedCallback() {
      document.addEventListener('view-as:update', this.handleUpdateRef);
    }
  }

  customElements.define('view-as', ViewAs);
}
